import React from 'react';
import { Link } from 'react-router-dom';
import './UpcomingEventsAndThemes.css';

function UpcomingEventsAndThemes() {
  return (
    <div className="upcoming-events-and-themes">
      <div className="upcoming-events-text-container">
        <div className="upcoming-events-title">Upcoming Events & Daily Themes</div>
        <div className="upcoming-events-description">
          Get ready for exciting events and unique daily themes at DJ's Dog Bar!
          <br /><br />
          From fun-filled dog-friendly activities to special promotions and live events, there's always something happening. 
          Whether you want to join a dog costume party or enjoy a live music night, we’ve got you covered!
          <br /><br />
          Interested in seeing more? <Link to="/Events" className="events-link">Check out our full list of upcoming events here.</Link>
        </div>
      </div>
      <div className="upcoming-events-image">
        <img src="https://res.cloudinary.com/dboapnol9/image/upload/v1779136051/DSC_0579_icyy8i.jpg" alt="Several dogs playing together on the lawn during an event at DJ's Dog Bar" />
      </div>
    </div>
  );
}

export default UpcomingEventsAndThemes;
